export const randomIntegerInRange = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const randString = (radix = 36) =>
  Math.random()
    .toString(radix)
    .slice(2);
